import { InjectionToken } from '@angular/core';
import { I18nService } from '../models';

export const I18N_SERVICE = new InjectionToken<I18nService>('I18N_SERVICE');
